import '../css/home-page.css';

export const PageNotFound = () => {
   return <h1 className='pageNotFound heading-1 display-flex'>Sorry! Page Not Found...</h1>
}